// GraphQL
import {
	CoreInvestmentTestCategoryChoices,
	CoreInvestmentTestExperienceChoices,
	useUserContextQuery,
} from "@/api/graphql"

// Navigation
import { Routes } from "@/constants/routes"
import { useNavigate } from "@/lib/router"

/**
 * useInvestmentTests
 * @returns
 */
export function useInvestmentTests() {
	const { data, refetch } = useUserContextQuery()

	// Navigate
	const navigate = useNavigate()

	// Hide badges when the test is already done
	const investorProfileExperience = data?.me?.investment_tests?.filter(
		(result) =>
			result.category === CoreInvestmentTestCategoryChoices.Experience,
	)[0]
	let investorTestQuestions = data?.me?.investment_tests?.filter(
		(result) =>
			result.category === CoreInvestmentTestCategoryChoices.Questions,
	)[0]
	let investorTestRisk = data?.me?.investment_tests?.filter(
		(result) =>
			result.category ===
			CoreInvestmentTestCategoryChoices.LossCalculator,
	)[0]
	/* const investorIdentity = (data?.me?.kyc?.state ===
		RiskKycStateChoices.VerificationSuccess) as Boolean */

	// How many required actions are there left?
	let amountOfRequiredActionsLeft = 0
	let requiredActions = {
		EXPERIENCE: !Boolean(investorProfileExperience),
		QUESTIONS:
			investorProfileExperience?.experience ===
			CoreInvestmentTestExperienceChoices.Novice
				? !Boolean(investorTestQuestions)
				: false,
		LOSS_CALCULATOR:
			investorProfileExperience?.experience ===
			CoreInvestmentTestExperienceChoices.Novice
				? !Boolean(investorTestRisk)
				: false,
	}

	// If any of these require action, set badge
	Object.keys(requiredActions).forEach((key) => {
		if (
			requiredActions[key as CoreInvestmentTestCategoryChoices] === true
		) {
			amountOfRequiredActionsLeft++
		}
	})

	// Determine next step URL
	const nextStep = Object.keys(requiredActions).find(
		(key) =>
			requiredActions[key as CoreInvestmentTestCategoryChoices] === true,
	)
	let nextStepUrl: string | undefined = undefined
	if (amountOfRequiredActionsLeft > 0) {
		switch (nextStep) {
			case CoreInvestmentTestCategoryChoices.Experience:
				nextStepUrl = Routes.InvestorProfile
				break
			case CoreInvestmentTestCategoryChoices.Questions:
				nextStepUrl = Routes.InvestorTest
				break
			case CoreInvestmentTestCategoryChoices.LossCalculator:
				nextStepUrl = Routes.InvestorRisk
				break
		}
	}

	/**
	 * Check which step is next and then redirect to that step
	 *
	 * TODO: Add KYC and IBAN
	 */
	function onRedirectToNextStep() {
		if (nextStepUrl) {
			navigate(nextStepUrl)
		}
	}

	return {
		refetch,
		investorProfileExperience,
		investorTestQuestions,
		investorTestRisk,
		amountOfRequiredActionsLeft,
		onRedirectToNextStep,
		nextStepUrl,
	}
}
